import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14649998"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"-30px"} }
const _hoisted_2 = {
  key: 0,
  style: {"float":"left","width":"115px"}
}
const _hoisted_3 = { style: {"white-space":"break-spaces","word-break":"break-all","word-wrap":"break-word"} }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"list-style-type":"none","margin-left":"30px"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"color":"rgb(254, 153, 91)"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "task" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_DArrowRight = _resolveComponent("DArrowRight")!
  const _component_order_pool_choose_service = _resolveComponent("order-pool-choose-service")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_order_task = _resolveComponent("order-task")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_order_supplier = _resolveComponent("order-supplier")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        _createVNode(_component_order_summary_time, {
          id: _ctx.detail.Data.OrderId
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_card, {
      bottomButtons: _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_button, {
          model: _ctx.btnTask,
          onHandleClick: _ctx.handleClick
        }, null, 8, ["model", "onHandleClick"]),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isShow==true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "   "))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle([{"float":"left"}, _ctx.isShow==true?'width: calc(100% - 115px)':'wdith:100%;'])
          }, [
            (
        _ctx.detail.Data.Status == _ctx.EnumOrderPoolStatus.WaitingAudit &&
        _ctx.logier?.CompanyType == 20
      )
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  class: "audit-alert",
                  title: "请点击左侧《委托书》，并进行审核操作",
                  type: "error",
                  effect: "light",
                  closable: false
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_miezz_form, {
              modelValue: _ctx.detail,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detail) = $event)),
              isDetail: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'SalesmanLabel')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: item.Label,
                      prop: item.Prop
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.detail.Data.SalesmanLabel) + " ", 1),
                        _createVNode(_component_miezz_button, {
                          model: _ctx.btnUpdateSalesman,
                          onHandleClick: _ctx.handleClick
                        }, null, 8, ["model", "onHandleClick"])
                      ]),
                      _: 2
                    }, 1032, ["label", "prop"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'CustomerSupplierLabel')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          disabled: _ctx.detail.Data.tooltipFlag
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.detail.Data.CustomerSupplierLabel ?? "暂无数据"), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "text-ellipsis",
                              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visibilityChange($event)))
                            }, _toDisplayString(_ctx.detail.Data.CustomerSupplierLabel ?? "暂无数据"), 33)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'TransportDirection')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_el_form_item, {
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.type), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"])
                    ]))
                  : (
            item.Prop == 'DeparturePortBooking' &&
            _ctx.detail.Data.TransportDirection != _ctx.EnumTransportDirection.Other
          )
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        prop: item.Prop,
                        label: item.Label,
                        class: "services-check-group"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.detail.Data.DeparturePortBooking,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.Data.DeparturePortBooking) = $event)),
                            label: "订舱",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          (_ctx.detail.Data.DeparturePortBooking)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "是否签发提单"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.detail.Data.DeparturePortLadingBill ? "是" : "否"), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_form_item, { key: 1 })),
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.detail.Data.DeparturePortTake,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.Data.DeparturePortTake) = $event)),
                            label: "提/送",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          (_ctx.detail.Data.DeparturePortTake)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                label: "方式",
                                prop: "DeparturePortTakeMethod"
                              }, {
                                default: _withCtx(() => [
                                  (
                _ctx.detail.Data.TransportContainerLoad ==
                _ctx.EnumTransportContainerLoad.FCL
              )
                                    ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                        key: 0,
                                        label: "集装箱拖车",
                                        modelValue: _ctx.detail.Data.DeparturePortContainer,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.Data.DeparturePortContainer) = $event)),
                                        disabled: true
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_checkbox, {
                                    label: "干线物流",
                                    modelValue: _ctx.detail.Data.DeparturePortTrunk,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.Data.DeparturePortTrunk) = $event)),
                                    disabled: true
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_el_checkbox, {
                                    label: "快递",
                                    modelValue: _ctx.detail.Data.DeparturePortExpress,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.Data.DeparturePortExpress) = $event)),
                                    disabled: true
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_form_item, { key: 3 })),
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.detail.Data.DeparturePortWarehouse,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.Data.DeparturePortWarehouse) = $event)),
                            label: "仓库/堆场/码头",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_el_form_item),
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.detail.Data.DeparturePortDeclareCustoms,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.Data.DeparturePortDeclareCustoms) = $event)),
                            label: "报关",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          (
              _ctx.detail.Data.DeparturePortDeclareCustoms &&
              _ctx.detail.Data.TransportDirection != _ctx.EnumTransportDirection.Import
            )
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 4,
                                label: "是否退税"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.detail.Data.DeparturePortDrawback ? "是" : "否"), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_form_item, { key: 5 }))
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : (
            item.Prop == 'DestinationPortClearCustoms' &&
            _ctx.detail.Data.TransportDirection != _ctx.EnumTransportDirection.Other
          )
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 4,
                          prop: item.Prop,
                          label: item.Label,
                          class: "services-check-group"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.detail.Data.DestinationPortClearCustoms,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detail.Data.DestinationPortClearCustoms) = $event)),
                              label: "清关",
                              disabled: true
                            }, null, 8, ["modelValue"]),
                            (_ctx.detail.Data.DestinationPortClearCustoms)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "清关抬头"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.destinationPortCustomsClearanceHeaderProvider), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_form_item, { key: 1 })),
                            (
              _ctx.detail.Data.DestinationPortClearCustoms &&
              _ctx.detail.Data.DestinationPortCustomsClearanceHeaderProvider ==
                _ctx.EnumCustomsClearanceHeaderProvider.ServiceProvider
            )
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 2,
                                  label: "是否出具税单",
                                  style: {"margin-left":"172px","margin-top":"5px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.detail.Data.DestinationPortCustomsClearanceIssueTaxReceipt
                ? "是"
                : "否"), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 3,
                                  style: {"margin-left":"172px"}
                                })),
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.detail.Data.DestinationPortDelivery,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detail.Data.DestinationPortDelivery) = $event)),
                              label: "提/送",
                              disabled: true
                            }, null, 8, ["modelValue"]),
                            (_ctx.detail.Data.DestinationPortDelivery)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 4,
                                  prop: "DestinationPortDeliveryMethod",
                                  label: "方式"
                                }, {
                                  default: _withCtx(() => [
                                    (
                _ctx.detail.Data.TransportType != _ctx.EnumTransportType.Air &&
                _ctx.detail.Data.TransportContainerLoad !=
                  _ctx.EnumTransportContainerLoad.Bulk
              )
                                      ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                          key: 0,
                                          label: "集装箱拖车",
                                          modelValue: _ctx.detail.Data.DestinationPortContainer,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.detail.Data.DestinationPortContainer) = $event)),
                                          disabled: true
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_checkbox, {
                                      label: "干线物流",
                                      modelValue: _ctx.detail.Data.DestinationPortTrunk,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.detail.Data.DestinationPortTrunk) = $event)),
                                      disabled: true
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_el_checkbox, {
                                      label: "快递",
                                      modelValue: _ctx.detail.Data.DestinationPortExpress,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.detail.Data.DestinationPortExpress) = $event)),
                                      disabled: true
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_el_form_item, { key: 5 })),
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.detail.Data.DestinationPortWarehouse,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detail.Data.DestinationPortWarehouse) = $event)),
                              label: "仓库/堆场/码头",
                              disabled: true
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      : (
            item.Prop == 'ServiceRemark' &&
            _ctx.detail.Data.TransportDirection != _ctx.EnumTransportDirection.Other
          )
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            prop: item.Prop,
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.detail.Data.ServiceRemark)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.detail.Data.ServiceRemark), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, "暂无数据"))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                (
            item.Prop == 'Suppliers' &&
            _ctx.logier?.CompanyType == _ctx.EnumCompanyType.ServiceProvider
          )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      label: item.Label,
                      prop: item.Prop
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_page_list, {
                          modelValue: _ctx.listSupplier,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.listSupplier) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label", "prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 4)
        ])
      ]),
      _: 1
    }, 8, ["bottomButtons", "onHandleFooterButtonClick"]),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
      ? (_openBlock(), _createBlock(_component_miezz_common_history, {
          key: 0,
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.histories) = $event)),
          isShow: _ctx.isShow,
          "label-width": "190px"
        }, null, 8, ["modelValue", "isShow"]))
      : _createCommentVNode("", true),
    (_ctx.isShow)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 1,
          class: "more-wrapper"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: {"position":"absolute","height":"calc(100% - 10px)","cursor":"pointer","display":"flex"},
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.changeShow && _ctx.changeShow(...args)))
            }, [
              _createVNode(_component_el_icon, { style: {"align-self":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_DArrowLeft)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btnMore.Options?.filter(
          (it) => !it.PowerCode || _ctx.powerCodes?.contains(it.PowerCode)
        ), (button, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.onClickLi(button))
                }, [
                  _createVNode(_component_el_button, {
                    type: "text",
                    style: _normalizeStyle(
            'font-size: 12px;' +
            (_ctx.$route.query.active == button.Code
              ? ' text-decoration: underline 2px; text-underline-offset: 5px'
              : '')
          )
                  }, {
                    default: _withCtx(() => [
                      (button.Active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(button.Label), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(button.Label), 1))
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ], 8, _hoisted_9))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "dArrowRight",
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.changeShow && _ctx.changeShow(...args)))
        }, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.detail.Data.TaskActiveCount), 1),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_DArrowRight)
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalChooseService,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalChooseService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_pool_choose_service, {
          modelValue: _ctx.modalChooseService,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalChooseService) = $event)),
          id: _ctx.id,
          onHandleSubmit: _ctx.handleChooseServiceSubmit
        }, null, 8, ["modelValue", "id", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_task, {
      modelValue: _ctx.modalTask,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalTask) = $event)),
      url: "/order/pool",
      listPower: "OrderManagement_Pool_Task",
      userPower: "OrderManagement_Pool",
      id: _ctx.id,
      cancel: _ctx.detail.Data.Status == _ctx.EnumOrderPoolStatus.Canceled
    }, null, 8, ["modelValue", "id", "cancel"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalUpdateSalesman,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modalUpdateSalesman) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-update-salesman",
          model: _ctx.formUpdateSalesman.Data,
          rules: _ctx.formUpdateSalesman.Rules,
          "label-width": "200px",
          inline: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "SalesmanId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.formUpdateSalesman.Data.SalesmanId,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formUpdateSalesman.Data.SalesmanId) = $event)),
                  label: _ctx.formUpdateSalesman.Data.SalesmanLabel,
                  "onUpdate:label": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formUpdateSalesman.Data.SalesmanLabel) = $event)),
                  options: _ctx.salesmans,
                  clearable: ""
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalDefaultSupplier,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.modalDefaultSupplier) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.listDefaultSupplier,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.listDefaultSupplier) = $event))
        }, {
          column: _withCtx(({ model, row }) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.handleChooseSupplier(model.Prop))
            }, [
              _createVNode(_component_miezz_text_ellipsis, {
                text: row[model.Prop],
                style: {"color":"#409eff"}
              }, null, 8, ["text"])
            ], 8, _hoisted_13)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_order_supplier, {
      ref: "ref-order-supplier",
      show: _ctx.showSupplier,
      canEdit: true,
      canSync: true,
      onHandleSave: _ctx.handleSaveSupplier
    }, null, 8, ["show", "onHandleSave"])
  ], 64))
}